import React, { useEffect } from 'react'
import actions from 'redux/actions'
import { mixpanel, constants } from 'common/helpers'

import Modal from 'components/modal/Modal/Modal'
import Title from 'site/client/components/_new/typography/deprecated/Title/Title'
import Box from 'site/client/components/_new/layout/Box/Box'
import ButtonsInRow from 'components/_new/buttons/ButtonsInRow/ButtonsInRow'
import Button from 'site/client/components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


const CustomAddressValidationModal = ({ name, data: { enteredAddress, onUse } }) => {
  useEffect(() => {
    mixpanel.track(constants.analyticsEvents.addressValidationPopup.open)
  }, [])

  const handleCloseClick = () => {
    mixpanel.track(constants.analyticsEvents.addressValidationPopup.close)
    actions.models.modals.close(name)
  }

  const handleUseClick = () => {
    actions.models.modals.close(name)

    onUse()
  }

  return (
    <Modal
      name={name}
      title={messages.title}
      onClose={handleCloseClick}
    >
      <Text message={messages.text} size="md" />
      <Box mt="24">
        <Title message={messages.youEntered} size="sm" />
        <Text message={enteredAddress} />
      </Box>
      <Box mt="36">
        <ButtonsInRow>
          <Button
            color="brand"
            size="md"
            title={messages.buttons.use}
            onClick={handleUseClick}
          />
          <Button
            color="brandBorder"
            size="md"
            title={messages.buttons.edit}
            onClick={handleCloseClick}
          />
        </ButtonsInRow>
      </Box>
    </Modal>
  )
}

CustomAddressValidationModal.defaultProps = {
  name: constants.modals.CustomAddressValidation,
}


export default CustomAddressValidationModal
